/**
 * @function roundToNearestHalf
 * @desc Rounds value to the nearest half.
 *
 * @param {Number} x - value that is rounded.
 * @returns {Number} number
 */

function roundToNearestHalf(x: number): number {
  return Math.round(x * 2) / 2;
}

export default roundToNearestHalf;
